'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styles$z = require('./styles-5b72d46e.js');

var DropdownItem = function (_a) {
    var _b;
    var active = _a.active, item = _a.item, lastItem = _a.lastItem, onSelect = _a.onSelect;
    var handleClick = React.useCallback(function () {
        onSelect(item);
    }, [item, onSelect]);
    var className = (_b = item.props) === null || _b === void 0 ? void 0 : _b.className;
    return (React__default.createElement(styles$z.Container, { active: active, lastItem: lastItem, onClick: handleClick, "data-testid": "hqo-dropdown-item", "data-cy": "hqo-dropdown-item", className: className }, item.element ? item.element : (React__default.createElement(styles$z.Text, null, item.label))));
};

exports.DropdownItem = DropdownItem;
